import { createElement } from 'react';
import { node } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import './styled/selector.js';
import 'lodash/get';
import './styled/space.js';
import styled from './styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';

var _VisuallyHidden = styled(Box).withConfig({
  displayName: "VisuallyHidden___VisuallyHidden",
  componentId: "ymx3x5-0"
})(["border:0px;clip:rect(0px,0px,0px,0px);height:1px;width:1px;margin:-1px;padding:0px;overflow:hidden;position:absolute;"]);

var VisuallyHidden = function VisuallyHidden(_ref) {
  var children = _ref.children;
  return createElement(_VisuallyHidden, null, children);
};
VisuallyHidden.propTypes = {
  children: node.isRequired
};

export default VisuallyHidden;
export { VisuallyHidden };
